import { StyledModalText } from "common/components";
import { useTranslate } from "common/utilities/useTranslate";
import { ModalHeader } from "domains/modal/components/ModalHeader";

export const ConfirmResetCoachmarksModal = () => {
  const translate = useTranslate();

  return (
    <>
      <ModalHeader title={translate("app.coachmarks.reset_confirmation_modal.title")} />
      <StyledModalText>{translate("app.coachmarks.reset_confirmation_modal.text")}</StyledModalText>
    </>
  );
};
